import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import Loading from '../components/general/Loading';

/**
 * Protection des routes de PILOTAGE COORDONNATEUR (programmation commune,
 * configuration des groupes, répartition par résultats).
 *
 * Jusqu'ici, seule la BARRE D'ONGLETS testait le rôle pour s'afficher : la
 * route, elle, restait ouverte. N'importe quel professeur tapant l'URL (ou
 * gardant un onglet ouvert après avoir perdu la casquette coordo) obtenait la
 * frise complète avec Importer / Ajouter / Éditer / Supprimer, sur la
 * programmation de toute sa matière. Même test que PilotageCoordoTabs.
 *
 * ⚠ Contrôle CÔTÉ FRONT uniquement : il retire l'accès à l'écran, il ne
 * remplace pas une autorisation serveur sur les écritures.
 */
const CoordoRoute = ({ children }) => {
    const { user, etablissementData } = useUser();

    // Données d'établissement pas encore arrivées : NE PAS conclure au refus
    // (un coordo qui arrive par URL directe ou rafraîchit la page serait
    // éjecté avant même que son profil ne soit connu).
    if (!user || !etablissementData) {
        return <Loading loadingText={"Vérification des droits ..."} />;
    }

    const prof = etablissementData?.professeurs?.find((p) => p.id === user?.id);
    const autorise = user?.role === 'professeur'
        && !!(prof?.coordonateur || prof?.delegue_affectation);

    // Redirection silencieuse vers l'accueil : pas d'écran de refus pour un
    // prof qui n'a simplement pas (ou plus) la casquette.
    if (!autorise) return <Navigate to="/home/" replace />;

    return children;
};

export default CoordoRoute;
